import { useEffect } from 'react';
import imgLoginBackground from '../assets/img_login_background_image.jpg';
import imgColorP200 from '../assets/img_color_p200.jpg';
import imgColorP300 from '../assets/img_color_p300.jpg';
import imgColorP400 from '../assets/img_color_p400.jpg';
import imgColorP500 from '../assets/img_color_p500.jpg';
import imgColorP600 from '../assets/img_color_p600.jpg';
import imgColorS75 from '../assets/img_color_s75.jpg';
import imgColorS100 from '../assets/img_color_s100.jpg';
import imgColorS200 from '../assets/img_color_s200.jpg';
import imgColorS300 from '../assets/img_color_s300.jpg';
import imgColorS400 from '../assets/img_color_s400.jpg';
import imgColorSf from '../assets/img_color_sf.jpg';
import imgColorLsf from '../assets/img_color_lsf.jpg';
import imgColorAl from '../assets/img_color_al.jpg';
import imgColorLal from '../assets/img_color_lal.jpg';
import imgColorDn from '../assets/img_color_dn.jpg';
import imgColorLdn from '../assets/img_color_ldn.jpg';
import iconScreenshot from '../assets/img_icon_image.jpg';
import logoScreenshot from '../assets/img_logo_image.jpg';
import splashScreenshot from '../assets/img_splash_image.jpg';
import rewardIconScreenshot from '../assets/img_reward_image.jpg';
import emptyBagIconScreenshot from '../assets/img_empty_bag_image.jpg';
import fullBagIconScreenshot from '../assets/img_full_bag_image.jpg';
import rewardNavigationIconScreenshot from '../assets/img_reward_navigation_image.jpg';
import contactEmailScreenshot from '../assets/img_contact_email_image.jpg';
import privacyPolicyScreenshot from '../assets/img_privacy_policy_image.jpg';
import termOfServiceScreenshot from '../assets/img_term_of_service_image.jpg';
import aboutUsScreenshot from '../assets/img_about_us_image.jpg';
import complaintsScreenshot from '../assets/img_complaints_image.jpg';

async function preloadImage(src: string) {
  return await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      resolve(img);
    };
    img.onerror = img.onabort = function () {
      reject(src);
    };
    img.src = src;
  });
}

export default function usePreload() {
  useEffect(() => {
    const load = async () => {
      const images = [
        imgLoginBackground,
        imgColorP200,
        imgColorP300,
        imgColorP400,
        imgColorP500,
        imgColorP600,
        imgColorS75,
        imgColorS100,
        imgColorS200,
        imgColorS300,
        imgColorS400,
        imgColorSf,
        imgColorLsf,
        imgColorAl,
        imgColorLal,
        imgColorDn,
        imgColorLdn,
        iconScreenshot,
        logoScreenshot,
        splashScreenshot,
        rewardIconScreenshot,
        emptyBagIconScreenshot,
        fullBagIconScreenshot,
        rewardNavigationIconScreenshot,
        contactEmailScreenshot,
        privacyPolicyScreenshot,
        termOfServiceScreenshot,
        aboutUsScreenshot,
        complaintsScreenshot,
      ];
      await Promise.all(images.map(preloadImage));
    };
    load().catch((_) => {});
  });
}
